import { Component, OnInit, ViewChild } from '@angular/core';
import { ModelLocatorService } from 'src/app/services/config/model-locator.service';
import { OfferService } from 'src/app/services/offer-service/offer.service';

@Component({
    selector: 'app-mm-info-offer',
    templateUrl: './mm-info-offer.component.html',
    styleUrls: ['./mm-info-offer.component.scss'],
})
export class MmInfoOfferComponent implements OnInit {

    listInfoOffer: any = [];
    showInfo: any = {};
    @ViewChild('popover') popover!: HTMLIonPopoverElement;
    isOpen = false;

    constructor(private offerService: OfferService,
        public modelLocator: ModelLocatorService
    ) { }

    ngOnInit() {
    }

    async ngAfterViewInit() {
        await this.offerService.getOffers().then((res: any) => {
            console.log("🚀 ~ MmInfoOfferComponent ~ awaitthis.offerService.getOffers ~ res:", res);
            this.listInfoOffer = res.result;
        }).catch(error => {
            console.log("🚀 ~ MmInfoOfferComponent ~ awaitthis.offerService.getOffers ~ error:", error);
        });
    }

    touchShowModal(
        item: any
    ) {
        this.showInfo = item;
        this.isOpen = true;
    }

}
